import { Injectable } from "@angular/core";
import { HttpService } from "../../http/http";
import { DynamicPromoRepository } from "../../../domain/dynamic-promo-repository";
import { DynamicPromo, DynamicPromoInfo } from "../../../domain/dyanmicPromo";
import { toJson } from "../graphics/graphics.mapper";

@Injectable()
export class DynamicPromoRepositoryImpl implements DynamicPromoRepository {
  constructor(private httpService: HttpService) {}

  getDynamicPromos() {
    return this.httpService.get("DynamicPromo");
  }

  createDynamicPromo(dynamicPromo: DynamicPromo) {
    return this.httpService.post("DynamicPromo", {
      name: dynamicPromo.name,
      mediaId: dynamicPromo.mediaId,
      graphicsId: dynamicPromo.graphicsId,
      startGraphicOffsetSeconds: dynamicPromo.startGraphicOffsetSeconds,
      trailerId: dynamicPromo.trailerId,
    });
  }

  updateDynamicPromo(dynamicPromoInfo: DynamicPromoInfo) {
    let fields = dynamicPromoInfo.graphicsInfo.fields.map((field) => {
      return { id: field.id, value: toJson(field) };
    });
    return this.httpService.put(`DynamicPromo/${dynamicPromoInfo.id}`, {
      name: dynamicPromoInfo.name,
      mediaId: dynamicPromoInfo.mediaInfo.id,
      graphicsId: dynamicPromoInfo.graphicsInfo.id,
      graphicFields: fields,
      startGraphicOffsetSeconds: dynamicPromoInfo.startGraphicOffsetSeconds,
      trailerId: dynamicPromoInfo.trailerId,
    });
  }

  getDynamicPromo(id: string) {
    return this.httpService.get(`DynamicPromo/${id}`);
  }

  deleteDynamicPromo(id: string) {
    return this.httpService.delete(`DynamicPromo/${id}`);
  }

  getTimespotDefaults() {
    return this.httpService.get("dynamicPromo/GetDefaultTimeSpots");
  }
}
